import * as React from "react";

import { PbrCard } from "src/components/common/PbrCard/PbrCard";
import DataGrid, { Column, Pager, Paging, FilterRow, HeaderFilter, GroupPanel, Grouping, Selection, Export, MasterDetail } from "devextreme-react/data-grid";
import UploadButtonComponent from "./components/UploadButtonComponent";
import DocumentsDetailComponent from "./components/DocumentsDetailComponent";
import { Helpers } from "./helpers";
import { Spin } from "antd";

const UploadDocsView = (props: { loading: boolean; data: any; setLoading: any; helpers: Helpers }) => {
  const { loading, data, setLoading, helpers } = props;
  return (
    <PbrCard title={"Upload de Documentos"} bordered={false} style={{ width: "100%" }}>
      <Spin spinning={loading} tip="Carregando">
        <DataGrid
          dataSource={data}
          allowColumnReordering={true}
          showBorders={true}
          loadPanel={{ enabled: loading }}
          rowAlternationEnabled={true}
          hoverStateEnabled={true}
          columnAutoWidth={true}
        >
          <GroupPanel visible={true} />
          <Grouping autoExpandAll={true} />
          <Selection mode={"multiple"} selectAllMode={true} showCheckBoxesMode={true} />
          <FilterRow visible={true} />
          <HeaderFilter visible={true} />
          <Column caption="CNH/RG" alignment={"center"} cellComponent={e => <UploadButtonComponent e={e} typeTitle={"CPF/CNPJ"} setLoading={setLoading} helpers={helpers} />} />
          <Column
            caption="Comprovante Residencial"
            alignment={"center"}
            cellComponent={e => <UploadButtonComponent e={e} typeTitle={"Comprovante Residencial"} setLoading={setLoading} helpers={helpers} />}
          />
          <Column
            caption="Certidão de Casamento"
            alignment={"center"}
            cellComponent={e => <UploadButtonComponent e={e} typeTitle={"Certidão de Casamento"} setLoading={setLoading} helpers={helpers} />}
          />
          <Column caption="ID" alignment={"center"} dataField="id" dataType="number" />
          <Column caption="Nome" alignment={"center"} dataField="tradeOwner.fullName" dataType="string" />
          <Column caption="CPF/CNPJ" alignment={"center"} dataField="tradeOwner.cpfCnpj" dataType="string" />
          <MasterDetail enabled={true} render={e => <DocumentsDetailComponent dataFromParent={e} helpers={helpers} />} />
          <Pager allowedPageSizes={[10, 25, 50, 100]} showPageSizeSelector={true} />
          <Paging defaultPageSize={10} />
          <Export enabled={true} fileName={"Precatorios_Entubados_Documentos"} allowExportSelectedData={true} />
        </DataGrid>
      </Spin>
    </PbrCard>
  );
};

export default UploadDocsView;



// WEBPACK FOOTER //
// ./src/pages/monitor/upload/UploadDocsView.tsx